import type { PageContent } from "../types";

export const services: PageContent = {
  slug: "services",
  title: `Digital Marketing & Web Services | Phil Carr`,
  description: `Explore SEO, web design, WordPress, Shopify, hosting, and website management services that help Barnsley and UK businesses grow online.`,
  body: `# Services that help you grow

From search visibility to high-converting websites, I provide the strategy and hands-on
delivery to keep your marketing moving. Explore the services below, or [book a call](/contact "Book a discovery call")
to talk through your goals.

[Book a discovery call](/contact "Book a discovery call")

[Learn about Phil](/about "Learn about Phil Carr")

![Service strategy overview illustration](/images/services-hero.svg)

### Service overview

## Choose the support that fits your next  move

Every engagement starts with clear goals, a focused
strategy, and a plan for measurable results. These are the core services available right now.

![SEO strategy](/images/icon-about-agency-1.svg)

### [SEO strategy &\\  execution](/seo "SEO services")

Technical audits, content planning, and authority building that grow organic traffic.

[Explore SEO](/seo "Explore SEO services")

[SEO Audits](/seo/bespoke-seo-website-audits "Bespoke SEO Website Audits") ·
[Organic SEO](/seo/organic-seo-services "Organic SEO Services") ·
[Link Outreach](/seo/link-building-outreach "Link Building Outreach") ·
[Technical SEO](/seo/technical-seo-support "Technical SEO Support")

[Barnsley SEO](/seo/barnsley "SEO Barnsley") ·
[Doncaster SEO](/seo/doncaster "SEO Doncaster") ·
[Huddersfield SEO](/seo/huddersfield "SEO Huddersfield") ·
[Leeds SEO](/seo/leeds "SEO Leeds") ·
[Rotherham SEO](/seo/rotherham "SEO Rotherham") ·
[Sheffield SEO](/seo/sheffield "SEO Sheffield") ·
[Wakefield SEO](/seo/wakefield "SEO Wakefield")

![Web design](/images/icon-about-agency-2.svg)

### [Conversion-led web\\  design](/web-design "Web design")

Layouts, messaging, and UX designed to turn visits into enquiries.

[Explore web design](/web-design "Explore web design")

![WordPress websites](/images/icon-about-agency-3.svg)

### [WordPress\\  websites](/wordpress-websites "WordPress websites")

Flexible, editor-friendly sites built with performance and scalability in mind.

[Explore WordPress](/wordpress-websites "Explore WordPress websites")

![Shopify stores](/images/icon-about-agency-4.svg)

### [Shopify\\  ecommerce builds](/shopify-websites "Shopify websites")

High-converting storefronts, product setup, and ecommerce workflows built for growth.

[Explore Shopify](/shopify-websites "Explore Shopify websites")

![Website management](/images/icon-about-agency-5.svg)

### [Website\\  management](/website-management "Website management")

Content updates, performance monitoring, and monthly improvements to keep sites healthy.

[Explore management](/website-management "Explore website management")

![Hosting](/images/icon-about-agency-6.svg)

### [Hosting & technical care](/hosting "Hosting")

Secure hosting, backups, and speed optimisation to keep your website online and quick.

[Explore hosting](/hosting "Explore hosting")

### Local & national coverage

## Supporting Barnsley and UK  businesses

Work is delivered remotely across the UK, with a
strong local focus in South Yorkshire. If you are nearby, explore the [areas covered](/areas "Areas served") or connect about a local
project.

- Onboarding, audits, and proposals handled within 5 working days
- Monthly reporting that ties activity to measurable growth
- Flexible support for one-off builds or ongoing retainers
- Clear next steps after every milestone

[Discuss your project](/contact "Discuss your project")

![Project planning](/images/generated/page-hero-seo-consulting.jpg)

### FAQs
## Common questions about working together
## Which service should I start with?

If your website is not converting, start with a [web design review](/web-design "Web design"). If traffic is
the priority, begin with an [SEO\\\\
audit](/seo "SEO audit"). I can map the best route on a discovery call.

## Do you offer one-off projects?

Yes. You can book standalone builds, audits, or migrations. Ongoing support is
available through [website management](/website-management "Website management") plans.

## Can you host and support the website too?

Absolutely. Choose [hosting](/hosting "Hosting")
with ongoing updates, backups, and performance monitoring baked in.

[Back to Top](/#top)

We use cookies to improve your experience, analyse site traffic, and understand how you interact with
our content. Read our [cookie policy](/cookies) to learn more.

Reject optionalAccept cookies [Privacy policy](/privacy-policy)

reCAPTCHA

Recaptcha requires verification.

protected by **reCAPTCHA**`,
};
